import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
import Home from '../views/Home.vue'
import UserInfo from '../views/UserInfo'
import Qusetion from '../views/Question.vue'
import Result from '../views/Result'

Vue.use(VueRouter)
Vue.use(VueAwesomeSwiper, /* { default global options } */)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },{
    path: '/UserInfo',
    name: 'UserInfo',
    component: UserInfo
  },{
    path: '/Qusetion',
    name: 'Qusetion',
    component: Qusetion
  },{
    path: '/Result',
    name: 'Result',
    component: Result
  },
  
]

const router = new VueRouter({
  routes
})

export default router
